<template>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="1000px" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form ref="form" :model="form" :rules="rules" label-width="120px" style="margin-top: 20px" label-position="left">
            <el-row type="flex" style="flex-wrap: wrap" :gutter="30">
                <el-col :span="12">
                    <el-form-item label="发票抬头" prop="invoiceTitle">
                        <el-autocomplete
                            class="inline-input"
                            v-model="form.invoiceTitle"
                            :debounce="300"
                            :trigger-on-focus="false"
                            :select-when-unmatched="true"
                            :fetch-suggestions="searchInvoiceHeadList"
                            placeholder="请输入发票抬头"
                            style="width: 100%"
                            @select="handleSelect"></el-autocomplete>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="企业税号" prop="enterpriseTaxNumber">
                        <el-input v-model="form.enterpriseTaxNumber" placeholder="请输入企业税号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="开户行名称" prop="openBankName">
                        <el-input v-model="form.openBankName" placeholder="请输入开户行名称"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="开户行账户" prop="openBankAccount">
                        <el-input v-model="form.openBankAccount" placeholder="请输入开户行账户"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="注册地址" prop="registeredAddress">
                        <el-input v-model="form.registeredAddress" placeholder="请输入注册地址"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="注册电话" prop="registeredTelephone">
                        <el-input v-model="form.registeredTelephone" placeholder="请输入注册电话"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="收件人姓名" prop="addressee">
                        <el-input v-model="form.addressee" placeholder="请输入收件人姓名"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="收件地址" prop="deliveryAddress">
                        <el-input v-model="form.deliveryAddress" placeholder="请输入收件地址"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="收件邮箱" prop="receivingContact">
                        <el-input v-model="form.receivingContact" placeholder="请输入收件邮箱"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="联系方式" prop="receivingContactInformation">
                        <el-input v-model="form.receivingContactInformation" placeholder="请输入联系方式"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div slot="footer" class="footer_btn">
            <el-button type="primary" size="small" style="width: 80px" plain @click="close(false)">取消</el-button>
            <el-button type="primary" size="small" style="width: 80px" @click="submitHandle()" v-preventClick>提交</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { saveInvoiceHead, getInvoiceHeadContrastList } from '@/api/request';
import { isMobile, isLandline, validEmail, validEnterpriseTax, validOpenBankAccount, validSpace } from '@/plugins/validate.js'


export default {
    components: {},
    data() {
        const validateSpace = (rule, value, callback) => {
            if(validSpace(value)) {
                return callback(new Error('不能存在空格、换行等'));
            }
            callback();
        }
        const validateMobile = (rule, value, callback) => {
            if (value && !(isMobile(value) || isLandline(value))) {
                return callback(new Error('请输入正确的手机号'));
            }
            callback();
        };
        const validemail = (rule, value, callback) => {
            if (value && !validEmail(value)) {
                return callback(new Error('请输入正确的邮箱'));
            }
            callback();
        };
        //校验税号不能含有空格
        const validateEnterpriseTax = (rule, value, callback) => {
            if (value && !validEnterpriseTax(value)) {
                return callback(new Error('请输入正确的企业税号'));
            }
            callback();
        }
        //校验开户行账户
        const validateOpenBankAccount = (rule, value, callback) => {
            if (value && !validOpenBankAccount(value)) {
                return callback(new Error('请输入正确的开户行账户'));
            }
            callback();
        }
        return {
            dialogVisible: false,
            title: '新增发票抬头',
            form: {
                invoiceTitle: '',
                enterpriseTaxNumber: '',
                openBankName: '',
                openBankAccount: '',
                registeredAddress: '',
                registeredTelephone: '',
                addressee: '',
                deliveryAddress: '',
                receivingContact: '',
                receivingContactInformation: ''
            },
            rules: {
                invoiceTitle: [
                    { required: true, trigger: 'blur', message: '请输入发票抬头' },
                    { max: 50, message: '发票抬头不能超过50个字', trigger: 'blur' },
                    { validator: validateSpace, trigger: 'blur' },
                ],
                enterpriseTaxNumber: [
                    { required: true, trigger: 'blur', message: '请输入企业税号' },
                    { max: 20, message: '企业税号不能超过20个字', trigger: 'blur' },
                    { validator: validateEnterpriseTax, trigger: 'blur' },
                    { validator: validateSpace, trigger: 'blur' },
                ],
                addressee: [
                    { required: true, trigger: 'blur', message: '请输入收件人姓名' },
                    { max: 20, message: '收件人姓名不能超过20个字', trigger: 'blur' },
                    { validator: validateSpace, trigger: 'blur' },
                ],
                openBankName: [
                    { max: 50, message: '开户行名称不能超过50个字', trigger: 'blur' },
                    { validator: validateSpace, trigger: 'blur' },
                ],
                openBankAccount: [
                    { max: 20, message: '开户行账号不能超过20个字', trigger: 'blur' },
                    { validator: validateOpenBankAccount, trigger: 'blur' },
                    { validator: validateSpace, trigger: 'blur' },
                ],
                registeredAddress: [
                    { max: 50, message: '注册地址不能超过50个字', trigger: 'blur' },
                    { validator: validateSpace, trigger: 'blur' },
                ],
                registeredTelephone: [
                    { validator: validateMobile, trigger: 'blur' },
                    { validator: validateSpace, trigger: 'blur' },
                ],
                deliveryAddress: [
                    { required: true, trigger: 'blur', message: '请输入收件地址' },
                    { max: 50, message: '收件地址不能超过50个字', trigger: 'blur' },
                    { validator: validateSpace, trigger: 'blur' },
                ],
                receivingContact: [
                    { required: true, trigger: 'blur', message: '请输入收件邮箱' },
                    { validator: validemail, trigger: 'blur' },
                    { validator: validateSpace, trigger: 'blur' },
                ],
                receivingContactInformation: [
                    { required: true, trigger: 'blur', message: '请输入收件联系方式' },
                    { validator: validateMobile, trigger: 'blur' },
                    { validator: validateSpace, trigger: 'blur' },
                ]
            }
        };
    },
    methods: {
        init(info) {
            this.dialogVisible = true;
            if (info) {
                this.title = '修改发票抬头';
                this.form = JSON.parse(JSON.stringify(info));
            }
        },
        //获取发票抬头
        searchInvoiceHeadList(val, cb) {
            getInvoiceHeadContrastList({ invoiceTitle: val }).then((res) => {
                console.log(res);
                let headList = res.rows.map((x) => ({
                    ...x,
                    value: x.invoiceTitle,
                    id: x.id,
                    label: x.invoiceTitle
                }));
                this.headList = headList;
                cb(headList);
            });
        },
        handleSelect(e) {
            let data = this.headList.filter((item) => {
                return item.id == e.id;
            });
            this.form.registeredAddress = data[0].registeredAddress;
            this.form.enterpriseTaxNumber = data[0].enterpriseTaxNumber;
            console.log(this.form);
        },
        //确认结果
        submitHandle() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    saveInvoiceHead(this.form).then((res) => {
                        this.$message.success('操作成功');
                        this.close(true);
                    });
                } else {
                    return false;
                }
            });
        },
        close(flag) {
            this.dialogVisible = false;
            this.$emit('close',flag);
        }
    }
};
</script>

<style lang="scss" scoped>
.footer_btn {
    width: 100%;
    display: flex;
    justify-content: center;
}
</style>
